import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import { buildQueryParams } from '@warp-drive/utilities';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';
import type { Store as StoreService } from '@warp-drive/core';

export default class AuthenticatedAdminEmployeesShowRoute extends Route {
  @service declare store: StoreService;

  includes = [
    'company',
    'user',
    'user.accounts',
    'user.recommendations',
    'plan',
    'jurisdictive-relationships.delegate-of',
    'tags',
    'employee-addition',
    'tas-participant',
    'tas-eligibilities.tas-program-template',
  ];

  async model(params: { employee_id: string }) {
    // FindRecordOptions only accepts `include` as a query param; append
    // sparse-fieldset keys manually so they reach the wire.
    const req = findRecord<EmployeeModel>('employee', params.employee_id, {
      include: this.includes,
      backgroundReload: true,
    });
    req.url = `${req.url}&${buildQueryParams({ 'fields[user]': 'created-at,updated-at,id' })}`;
    const { content } = (await this.store.request(req)) as {
      content: { data: EmployeeModel };
    };
    return content.data;
  }
}
